export const modalToSearchThemeByCompany = {
    title: 'Search company',
    company: 'Company Name',
    placeholder: 'Please type in English',
    listTitle: 'Company List',
    countText: 'Matched: ',
    countNumber: 'companies',
    noDataText: '※ If you input company name, the searched results will be displayed'
}
